/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ManOfTheMatch = {
    properties: {
        user: {
            type: 'ManOfTheMatchUserVotesList',
            isRequired: true,
        },
        votes: {
            type: 'ManOfTheMatchListElementList',
            isRequired: true,
        },
    },
} as const;
